type DeepMapCallback = (value: any) => any

export function deepMap(obj: Record<string, any>, cb: DeepMapCallback): any {
	function mapValue(value: any): any {
		if (Array.isArray(value)) {
			return value.map((item) => mapValue(item))
		} else if (typeof value === 'object' && value !== null) {
			const result: Record<string, any> = {}
			for (const key in value) {
				if (Object.prototype.hasOwnProperty.call(value, key)) {
					result[key] = mapValue(value[key])
				}
			}
			return result
		} else {
			return cb(value)
		}
	}

	return mapValue(obj)
}

export const pipeProviders = <T>(...fns: Array<Function>) => (x: T) => fns.reduce((v, f) => f(v), x)
